import React from 'react';
import { Timeline } from 'primereact/timeline';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { resolveRoleText, resolveStepStatusText, stepStatusSeverity } from '../../../../../utils/dealerApprovalEnums';
import { formatDateWithTime } from '../../../../../utils/dateUtils';

const ApprovalSteps = ({ steps = [], currentStepOrder }) => {
    const { th } = useLanguage();

    const marker = (item) => {
        const isCurrent = item.stepOrder === currentStepOrder;
        const color = isCurrent ? 'var(--primary-color)' : 'var(--surface-400)';
        return (
            <span
                className="flex align-items-center justify-content-center border-circle"
                style={{ width: '2rem', height: '2rem', backgroundColor: color, color: '#fff' }}
            >
                {item.stepOrder}
            </span>
        );
    };

    const content = (item) => (
        <div className="mb-3">
            <div className="flex align-items-center gap-2">
                <span className="font-bold">{resolveRoleText(th, item.role)}</span>
                <Tag value={resolveStepStatusText(th, item.status)} severity={stepStatusSeverity(item.status)} />
            </div>
            {item.approverName && (
                <div className="text-sm mt-1">
                    {th('dealerApproval.approver')}: {item.approverName}
                    {item.actionDate ? ` — ${formatDateWithTime(item.actionDate, true)}` : ''}
                </div>
            )}
            {item.note && <div className="text-sm mt-1 font-italic">“{item.note}”</div>}
        </div>
    );

    return (
        <div>
            <h5>{th('dealerApproval.stepsTitle')}</h5>
            <Timeline className="da-timeline" align="left" value={steps} marker={marker} content={content} />
        </div>
    );
};

export default ApprovalSteps;
